import { useMyCustomers } from '~/common/hooks';
import {
  SharedCustomerSelector,
  useCustomerChangeHandler,
} from '~/purchase/components';

function PrimaryCustomerSelector() {
  const getCustomersByUser = useMyCustomers();
  const onChange = useCustomerChangeHandler();
  return (
    <SharedCustomerSelector
      customerQuery={getCustomersByUser}
      onChange={onChange}
    />
  );
}

export default PrimaryCustomerSelector;
